const LoadingPanel = () => (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image"></div>
    </div>
  );
export default LoadingPanel;
